module.exports = __webpack_public_path__ + "static/media/b20.b47b620c.png";